var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 11.8L6.5 10.6C5.5 9.60005 5 8.30005 5 7.10005C5 5.80005 5.5 4.50005 6.5 3.60005L5.3 2.40005C4 3.70005 3.3 5.40005 3.3 7.10005C3.3 8.80005 4 10.5 5.3 11.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 4.86374e-05L15.9 1.20005C17.5 2.80005 18.3 5.00005 18.3 7.10005C18.3 9.20005 17.5 11.4 15.9 13L17.1 14.2001C19.1 12.2 20 9.70005 20 7.10005C20 4.50005 19 2.00005 17.1 4.86374e-05Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 1.20005L2.9 4.86374e-05C1 2.00005 0 4.50005 0 7.10005C0 9.70005 1 12.2 2.9 14.2001L4.1 13C2.5 11.4 1.7 9.20005 1.7 7.10005C1.7 5.00005 2.5 2.80005 4.1 1.20005Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 11.8C16 10.5 16.7 8.80005 16.7 7.10005C16.6 5.40005 16 3.70005 14.7 2.40005L13.5 3.60005C14.5 4.60005 15 5.90005 15 7.10005C15 8.40005 14.5 9.70005 13.5 10.6L14.7 11.8Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.10005C12.5 5.72005 11.38 4.60005 10 4.60005C8.62 4.60005 7.5 5.72005 7.5 7.10005C7.5 7.86005 7.84 8.52005 8.37 8.98005L5 19.1H7L7.67 17.1H12.34L13 19.1H15L11.63 8.98005C12.16 8.52005 12.5 7.86005 12.5 7.10005ZM8.33 15.1L10 10.1L11.67 15.1H8.33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellTower);
export default __webpack_public_path__ + "static/media/cell-tower.f4ccbd86e822792d55c2bfe3be85c9dc.svg";
export { ForwardRef as ReactComponent };